import script from "./modal_edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal_edit.vue?vue&type=script&setup=true&lang=ts"

import "./modal_edit.vue?vue&type=style&index=0&id=e0ca1fa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0ca1fa0"]])

export default __exports__